module.exports = __webpack_public_path__ + "img/element-choice.616bf58.svg";